import { lazy } from 'react';

export const FundPageLazy = lazy(() => import('./FundPage'));
